import { createApp } from 'vue'; // Import createApp from Vue 3
import App from './App.vue'; // Update file extension to .vue
import router from './router'; // Import your Vue Router instance
import { createI18n } from 'vue-i18n'; // Import createI18n from Vue I18n
import { messages } from './i18n-messages.js'; // Import your locale messages


// Create the Vue I18n instance
const i18n = createI18n({
  locale: 'km', // set locale
  messages // set locale messages
});

// Create the Vue app instance and mount it
createApp(App)
  .use(router) // Use Vue Router
  .use(i18n) // Use Vue I18n
  .mount('#app'); // Mount the app to the DOM element with id 'app'

